import Header from "../../../components/Header/Header";
import { Container } from "../../Privacy/Privacy";
import styled from "styled-components";
import { Body } from "../../../components/Text/Text";
import {StudentTable} from "../../../components/StudentTable/StudentTable";
import {getAuthData} from "../../../api/fetch";
import {useAuth} from "../../../contexts/auth-context";
import {useEffect, useState} from "react";
import {NewSpinner} from "../../../components/Spinner/NewSpinner";

const StyledBodyFullCaps = styled(Body)`
    font-weight: var(--fw-semi-bold);
    text-transform: uppercase;
    margin-bottom: 10px;
`;

const ContainerWrapper = styled.div`
    background-color: ${props => props.$grey ? 'var(--color-light)' : 'var(--color-white)'};
`

const TableWrapper = styled.div`
    overflow-x: auto;
`;

function Students() {
    const { token, appUser, logout } = useAuth();
    const [ data, setData ] = useState(null);
    const [ pending, setPending ] = useState(true);

    useEffect(() => {
        if (!token || !appUser) return;

        const getStudentData = async () => {
            setPending(true);
            const studentData = await getAuthData("website/students", appUser, token, logout);
            setData(studentData);
            setPending(false);
        }

        getStudentData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (pending) {
        return (
            <div>
                <Header fullWidth />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '100px' }}>
                    <NewSpinner />
                </div>
            </div>
        );
    }

    if (!data || data.error) {
        return null;
    }

    return (
        <>
            <title>Studenten &mdash; Jurist & Werk Congres</title>

            <Header
                fullWidth
                title={`${data.user?.name ? "Hallo " + data.user?.name +", bekijk" : "Bekijk"} hier de talenten`}
                description={`Hieronder vind je alle studenten die dit jaar deelnemen aan het congres. 
                De studenten onder ‘Geïnteresseerde studenten’ hebben bij aanmelding aangegeven graag met ${data.user?.office ?? "jouw kantoor"} in gesprek te gaan. 
                Bekijk hier hun CV's, cijferlijsten en motivatiebrieven. Aanvullende (contact)informatie is te vinden in de app.`}
            />

            <ContainerWrapper $grey>
                <Container>
                    <StyledBodyFullCaps>Geïnteresseerde Studenten</StyledBodyFullCaps>
                    <TableWrapper>
                        <StudentTable students={data.interestedStudents} />
                    </TableWrapper>
                </Container>
            </ContainerWrapper>

            <ContainerWrapper>
                <Container>
                    <StyledBodyFullCaps>Overige Studenten</StyledBodyFullCaps>
                    <TableWrapper>
                        <StudentTable students={data.otherStudents} />
                    </TableWrapper>
                </Container>
            </ContainerWrapper>

        </>
    )
}

export default Students;